import { gql, useMutation } from '@apollo/client';
import {
  UpdateDailymotionMutation,
  UpdateDailymotionMutationVariables,
} from '../../__generated__/queries-web';

const UPDATE_DAILYMOTION = gql`
  mutation UpdateDailymotion($brandKey: BrandKey!, $dailymotionPublicId: ID!) {
    importDailymotionVideo(
      brandKey: $brandKey
      dailymotionPublicId: $dailymotionPublicId
    ) {
      id
      status
      title
    }
  }
`;

export const useDailymotionUpdate = () =>
  useMutation<UpdateDailymotionMutation, UpdateDailymotionMutationVariables>(
    UPDATE_DAILYMOTION,
  );
